// import {
//   Document,
//   PDFViewer,
//   Page as PDFPage,
//   StyleSheet,
//   Text as PDFText,
//   View as PDFView,
//   Image as PDFImage
// } from '@react-pdf/renderer';
// import { getCurrentDateTime } from '../../../../../utils';

// const styles = StyleSheet.create({
//   page: {
//     padding: 20
//   },
//   heading: {
//     fontSize: 18,
//     textAlign: 'center',
//     marginBottom: 20
//   },
//   line: {
//     height: 0.6,
//     backgroundColor: 'black',
//     marginVertical: 10,
//     marginTop: '40px'
//   },
//   line2: {
//     height: 0.4,
//     backgroundColor: 'black',
//     marginVertical: 10
//   },
//   contentContainer: {
//     display: 'flex',
//     flexDirection: 'row',
//     justifyContent: 'space-between',
//     marginTop: 0,
//     marginBottom: 0,
//     border: '1px Solid black',
//     padding: '10px'
//   },
//   contentContainer2: {
//     display: 'flex',
//     flexDirection: 'row',
//     justifyContent: 'space-between',
//     marginTop: 10,
//     marginBottom: 0
//   },
//   column: {
//     flex: 1,
//     paddingHorizontal: 10
//   },
//   row: {
//     flexDirection: 'row',
//     marginBottom: 5
//   },
//   text: {
//     fontSize: 5,
//     display: 'inline-block'
//   },
//   textBold: {
//     fontSize: 9,
//     fontWeight: 'bold'
//   },
//   textUnderlined: {
//     textDecoration: 'underline'
//   },
//   table: {
//     display: 'table',
//     width: 'auto',
//     borderStyle: 'solid',
//     borderWidth: 1,
//     borderColor: '#bfbfbf',
//     marginTop: 5
//   },
//   table2: {
//     display: 'table',
//     width: '50%',
//     borderStyle: 'solid',
//     borderWidth: 1,
//     borderColor: '#bfbfbf',
//     marginTop: 50
//   },
//   tableRow: {
//     flexDirection: 'row'
//   },
//   tableColHeader: {
//     width: '14.28%',
//     borderStyle: 'solid',
//     borderWidth: 1,
//     borderColor: '#bfbfbf',
//     backgroundColor: '#f0f0f0',
//     padding: 5
//   },
//   tableCol: {
//     width: '12.28%',
//     borderStyle: 'solid',
//     borderWidth: 1,
//     borderColor: '#bfbfbf',
//     padding: 5
//   },
//   tableCellHeader: {
//     fontSize: 7,
//     fontWeight: 'bold'
//   },
//   tableCell: {
//     fontSize: 6
//   }
// });

// const fullScreenStyles = {
//   container: {
//     position: 'fixed',
//     top: 0,
//     left: 0,
//     width: '100vw',
//     height: '100vh',
//     zIndex: 1000,
//     backgroundColor: 'white'
//   }
// };

// const Page = ({ style, children, ...props }) => (
//   <PDFPage style={{ ...styles.page, ...style }} {...props}>
//     {children}
//   </PDFPage>
// );

// const View = ({ style, children, ...props }) => (
//   <PDFView style={{ ...style }} {...props}>
//     {children}
//   </PDFView>
// );

// const Text = ({ style, content, ...props }) => (
//   <PDFText style={{ ...styles.text, ...style }} {...props}>
//     {content}
//   </PDFText>
// );

// export const CollectionSummaryReport = ({ data }) => {
//   console.log(data);

//   return (
//     <div style={fullScreenStyles.container}>
//       <PDFViewer width="100%" height="100%" showToolbar>
//         <Document title="Collection Summary Report ">
//           <Page style={styles.page} size="A4" orientation="landscape">
//             <PDFImage
//               src="/logo_Hospital_m.jpeg"
//               style={{ width: '50%', height: '50px', marginBottom: 20, marginLeft: '170px' }}
//             />
//             <View style={styles.row}>
//               <Text style={styles.text}>User Wise Collection Summary</Text>
//             </View>
//             <View style={styles.table}>
//               <View style={styles.tableRow}>
//                 <View
//                   style={{
//                     width: '6.5%',
//                     borderStyle: 'solid',
//                     borderWidth: 1,
//                     borderColor: '#bfbfbf',
//                     backgroundColor: '#f0f0f0',
//                     padding: 5
//                   }}
//                 >
//                   <Text style={styles.tableCellHeader} content="Sr" />
//                 </View>
//                 <View
//                   style={{
//                     width: '12%',
//                     borderStyle: 'solid',
//                     borderWidth: 1,
//                     borderColor: '#bfbfbf',
//                     backgroundColor: '#f0f0f0',
//                     padding: 5
//                   }}
//                 >
//                   <Text style={styles.tableCellHeader} content="Bill Date" />
//                 </View>
//                 <View
//                   style={{
//                     width: '10%',
//                     borderStyle: 'solid',
//                     borderWidth: 1,
//                     borderColor: '#bfbfbf',
//                     backgroundColor: '#f0f0f0',
//                     padding: 5
//                   }}
//                 >
//                   <Text style={styles.tableCellHeader} content="type" />
//                 </View>
//                 <View
//                   style={{
//                     width: '18%',
//                     borderStyle: 'solid',
//                     borderWidth: 1,
//                     borderColor: '#bfbfbf',
//                     backgroundColor: '#f0f0f0',
//                     padding: 5
//                   }}
//                 >
//                   <Text style={styles.tableCellHeader} content="Patient Name" />
//                 </View>
//                 <View
//                   style={{
//                     width: '12%',
//                     borderStyle: 'solid',
//                     borderWidth: 1,
//                     borderColor: '#bfbfbf',
//                     backgroundColor: '#f0f0f0',
//                     padding: 5
//                   }}
//                 >
//                   <Text style={styles.tableCellHeader} content="Uhid No." />
//                 </View>
//                 <View
//                   style={{
//                     width: '12%',
//                     borderStyle: 'solid',
//                     borderWidth: 1,
//                     borderColor: '#bfbfbf',
//                     backgroundColor: '#f0f0f0',
//                     padding: 5
//                   }}
//                 >
//                   <Text style={styles.tableCellHeader} content="Adm No" />
//                 </View>
//                 <View
//                   style={{
//                     width: '12%',
//                     borderStyle: 'solid',
//                     borderWidth: 1,
//                     borderColor: '#bfbfbf',
//                     backgroundColor: '#f0f0f0',
//                     padding: 5
//                   }}
//                 >
//                   <Text style={styles.tableCellHeader} content="Paymode" />
//                 </View>
//                 <View
//                   style={{
//                     width: '10.28%',
//                     borderStyle: 'solid',
//                     borderWidth: 1,
//                     borderColor: '#bfbfbf',
//                     backgroundColor: '#f0f0f0',
//                     padding: 5
//                   }}
//                 >
//                   <Text style={styles.tableCellHeader} content="Txn No." />
//                 </View>
//                 <View
//                   style={{
//                     width: '22%',
//                     borderStyle: 'solid',
//                     borderWidth: 1,
//                     borderColor: '#bfbfbf',
//                     backgroundColor: '#f0f0f0',
//                     padding: 5
//                   }}
//                 >
//                   <Text style={styles.tableCellHeader} content="Consultant" />
//                 </View>
//                 <View style={styles.tableColHeader}>
//                   <Text style={styles.tableCellHeader} content="Services" />
//                 </View>
//                 <View style={styles.tableColHeader}>
//                   <Text style={styles.tableCellHeader} content="Panel" />
//                 </View>
//                 <View style={styles.tableColHeader}>
//                   <Text style={styles.tableCellHeader} content="Bill Amt." />
//                 </View>
//                 <View style={styles.tableColHeader}>
//                   <Text style={styles.tableCellHeader} content="Dis Amt." />
//                 </View>
//                 <View style={styles.tableColHeader}>
//                   <Text style={styles.tableCellHeader} content="Recd. Amt." />
//                 </View>
//                 <View style={styles.tableColHeader}>
//                   <Text style={styles.tableCellHeader} content="Bal. Amt." />
//                 </View>
//                 <View style={styles.tableColHeader}>
//                   <Text style={styles.tableCellHeader} content="Username" />
//                 </View>
//               </View>
//               {data &&
//                 data?.opdData?.data?.map((data, index) => (
//                   <View key={index} style={styles.tableRow}>
//                     <View
//                       style={{
//                         width: '6%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={index + 1} />
//                     </View>
//                     <View
//                       style={{
//                         width: '12%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={getCurrentDateTime('date', data.createdAt)} />
//                     </View>
//                     <View
//                       style={{
//                         width: '9%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content="OPD" />
//                     </View>
//                     <View
//                       style={{
//                         width: '19.5%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text
//                         style={styles.tableCell}
//                         content={`${data.name_suffix} ${data.first_name} ${data.last_name}`}
//                       />
//                     </View>
//                     <View
//                       style={{
//                         width: '11.28%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={data.uhid} />
//                     </View>
//                     <View
//                       style={{
//                         width: '14%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={data.adm_no_date} />
//                     </View>
//                     <View
//                       style={{
//                         width: '14%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={data.payment_mode} />
//                     </View>
//                     <View
//                       style={{
//                         width: '10%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={data.chq_card_no} />
//                     </View>
//                     <View
//                       style={{
//                         width: '20%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={data.consultant.name} />
//                     </View>
//                     <View
//                       style={{
//                         width: '15%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content="" />
//                     </View>
//                     <View
//                       style={{
//                         width: '15%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={data.sponsor.name} />
//                     </View>
//                     <View
//                       style={{
//                         width: '15%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={data.reg} />
//                     </View>
//                     <View
//                       style={{
//                         width: '15%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={data.disc} />
//                     </View>
//                     <View
//                       style={{
//                         width: '15%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={data.recd} />
//                     </View>
//                     <View
//                       style={{
//                         width: '15%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={data.bal} />
//                     </View>
//                     <View
//                       style={{
//                         width: '18%',
//                         borderStyle: 'solid',
//                         borderWidth: 1,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content="" />
//                     </View>
//                   </View>
//                 ))}
//               <View style={styles.tableRow}>
//                 <View style={styles.tableCol}>
//                   <Text style={styles.tableCell} content="OPD TOTAL" />
//                 </View>
//                 <View style={styles.tableCol}>
//                   <Text style={styles.tableCell} content={data?.opdData?.stats?.bill_amt} />
//                 </View>
//                 <View style={styles.tableCol}>
//                   <Text style={styles.tableCell} content={data?.opdData?.stats?.disc_amt} />
//                 </View>
//                 <View style={styles.tableCol}>
//                   <Text style={styles.tableCell} content={data?.opdData?.stats?.recd_amt} />
//                 </View>
//                 <View style={styles.tableCol}>
//                   <Text style={styles.tableCell} content={data?.opdData?.stats?.bal_amt} />
//                 </View>
//               </View>

//               {data &&
//                 data?.opdBillingData?.data?.map((data, index) => (
//                   <View key={index} style={styles.tableRow}>
//                     <View
//                       style={{
//                         width: '6%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={index + 1} />
//                     </View>
//                     <View
//                       style={{
//                         width: '12%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={getCurrentDateTime('date', data.createdAt)} />
//                     </View>
//                     <View
//                       style={{
//                         width: '9%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content="OPD Billing" />
//                     </View>
//                     <View
//                       style={{
//                         width: '19.5%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text
//                         style={styles.tableCell}
//                         content={`${data.patient.name_suffix} ${data.patient.first_name} ${data.patient.last_name}`}
//                       />
//                     </View>
//                     <View
//                       style={{
//                         width: '11.28%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={data.uhid} />
//                     </View>
//                     <View
//                       style={{
//                         width: '14%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={data.patient.adm_no_date} />
//                     </View>
//                     <View
//                       style={{
//                         width: '14%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={data.pay_mode} />
//                     </View>
//                     <View
//                       style={{
//                         width: '10%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={data.cheque_no} />
//                     </View>
//                     <View
//                       style={{
//                         width: '20%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={data.patient.consultant.name} />
//                     </View>
//                     <View
//                       style={{
//                         width: '15%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text
//                         style={styles.tableCell}
//                         content={data.service_items.map(({ service }) => service).join(', ')}
//                       />
//                     </View>
//                     <View
//                       style={{
//                         width: '15%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={data.patient.sponsor.name} />
//                     </View>
//                     <View
//                       style={{
//                         width: '15%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={data.total_amt} />
//                     </View>
//                     <View
//                       style={{
//                         width: '15%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={data.disc_amt} />
//                     </View>
//                     <View
//                       style={{
//                         width: '15%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={data.total_recd} />
//                     </View>
//                     <View
//                       style={{
//                         width: '15%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={data.balance_amt} />
//                     </View>
//                     <View
//                       style={{
//                         width: '18%',
//                         borderStyle: 'solid',
//                         borderWidth: 1,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content="" />
//                     </View>
//                   </View>
//                 ))}
//               <View style={styles.tableRow}>
//                 <View style={styles.tableCol}>
//                   <Text style={styles.tableCell} content="OPD Billing TOTAL" />
//                 </View>
//                 <View style={styles.tableCol}>
//                   <Text style={styles.tableCell} content={data?.opdBillingData?.stats?.bill_amt} />
//                 </View>
//                 <View style={styles.tableCol}>
//                   <Text style={styles.tableCell} content={data?.opdBillingData?.stats?.disc_amt} />
//                 </View>
//                 <View style={styles.tableCol}>
//                   <Text style={styles.tableCell} content={data?.opdBillingData?.stats?.recd_amt} />
//                 </View>
//                 <View style={styles.tableCol}>
//                   <Text style={styles.tableCell} content={data?.opdBillingData?.stats?.bal_amt} />
//                 </View>
//               </View>

//               {data &&
//                 data?.receiptVoucherData?.data?.map((data, index) => (
//                   <View key={index} style={styles.tableRow}>
//                     <View
//                       style={{
//                         width: '6%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={index + 1} />
//                     </View>
//                     <View
//                       style={{
//                         width: '12%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={getCurrentDateTime('date', data.createdAt)} />
//                     </View>
//                     <View
//                       style={{
//                         width: '9%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content="Receipt Voucher" />
//                     </View>
//                     <View
//                       style={{
//                         width: '19.5%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text
//                         style={styles.tableCell}
//                         content={`${data.patient.name_suffix} ${data.patient.first_name} ${data.patient.last_name}`}
//                       />
//                     </View>
//                     <View
//                       style={{
//                         width: '11.28%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={data.patient.uhid} />
//                     </View>
//                     <View
//                       style={{
//                         width: '14%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={data.patient.adm_no_date} />
//                     </View>
//                     <View
//                       style={{
//                         width: '14%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={data.payment_mode} />
//                     </View>
//                     <View
//                       style={{
//                         width: '10%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={''} />
//                     </View>
//                     <View
//                       style={{
//                         width: '20%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={data.patient.consultant.name} />
//                     </View>
//                     <View
//                       style={{
//                         width: '15%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={''} />
//                     </View>
//                     <View
//                       style={{
//                         width: '15%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={data.patient.sponsor.name} />
//                     </View>
//                     <View
//                       style={{
//                         width: '15%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={0} />
//                     </View>
//                     <View
//                       style={{
//                         width: '15%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={0} />
//                     </View>
//                     <View
//                       style={{
//                         width: '15%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={data.received_amount} />
//                     </View>
//                     <View
//                       style={{
//                         width: '15%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={0} />
//                     </View>
//                     <View
//                       style={{
//                         width: '18%',
//                         borderStyle: 'solid',
//                         borderWidth: 1,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content="" />
//                     </View>
//                   </View>
//                 ))}
//               <View style={styles.tableRow}>
//                 <View style={styles.tableCol}>
//                   <Text style={styles.tableCell} content="Receipt Voucher TOTAL" />
//                 </View>
//                 <View style={styles.tableCol}>
//                   <Text style={styles.tableCell} content={data?.receiptVoucherData?.stats?.bill_amt} />
//                 </View>
//                 <View style={styles.tableCol}>
//                   <Text style={styles.tableCell} content={data?.receiptVoucherData?.stats?.disc_amt} />
//                 </View>
//                 <View style={styles.tableCol}>
//                   <Text style={styles.tableCell} content={data?.receiptVoucherData?.stats?.recd_amt} />
//                 </View>
//                 <View style={styles.tableCol}>
//                   <Text style={styles.tableCell} content={data?.receiptVoucherData?.stats?.bal_amt} />
//                 </View>
//               </View>

//               {data &&
//                 data?.indoorServiceData?.data?.map((data, index) => (
//                   <View key={index} style={styles.tableRow}>
//                     <View
//                       style={{
//                         width: '6%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={index + 1} />
//                     </View>
//                     <View
//                       style={{
//                         width: '12%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={getCurrentDateTime('date', data.createdAt)} />
//                     </View>
//                     <View
//                       style={{
//                         width: '9%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content="IPD Billing" />
//                     </View>
//                     <View
//                       style={{
//                         width: '19.5%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text
//                         style={styles.tableCell}
//                         content={`${data.patient.name_suffix} ${data.patient.first_name} ${data.patient.last_name}`}
//                       />
//                     </View>
//                     <View
//                       style={{
//                         width: '11.28%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={data.uhid} />
//                     </View>
//                     <View
//                       style={{
//                         width: '14%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={data.patient.adm_no_date} />
//                     </View>
//                     <View
//                       style={{
//                         width: '14%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={data.pay_mode} />
//                     </View>
//                     <View
//                       style={{
//                         width: '10%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={data.cheque_no} />
//                     </View>
//                     <View
//                       style={{
//                         width: '20%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={data.patient.consultant.name} />
//                     </View>
//                     <View
//                       style={{
//                         width: '15%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text
//                         style={styles.tableCell}
//                         content={data.service_items.map(({ service }) => service).join(', ')}
//                       />
//                     </View>
//                     <View
//                       style={{
//                         width: '15%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={data.patient.sponsor.name} />
//                     </View>
//                     <View
//                       style={{
//                         width: '15%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={data.total_amt} />
//                     </View>
//                     <View
//                       style={{
//                         width: '15%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={data.disc_amt} />
//                     </View>
//                     <View
//                       style={{
//                         width: '15%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={data.total_recd} />
//                     </View>
//                     <View
//                       style={{
//                         width: '15%',
//                         borderStyle: 'solid',
//                         borderWidth: 0.5,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content={data.balance_amt} />
//                     </View>
//                     <View
//                       style={{
//                         width: '18%',
//                         borderStyle: 'solid',
//                         borderWidth: 1,
//                         borderColor: '#bfbfbf',
//                         padding: 5
//                       }}
//                     >
//                       <Text style={styles.tableCell} content="" />
//                     </View>
//                   </View>
//                 ))}
//               <View style={styles.tableRow}>
//                 <View style={styles.tableCol}>
//                   <Text style={styles.tableCell} content="IPD Billing TOTAL" />
//                 </View>
//                 <View style={styles.tableCol}>
//                   <Text style={styles.tableCell} content={data?.indoorServiceData?.stats?.bill_amt} />
//                 </View>
//                 <View style={styles.tableCol}>
//                   <Text style={styles.tableCell} content={data?.indoorServiceData?.stats?.disc_amt} />
//                 </View>
//                 <View style={styles.tableCol}>
//                   <Text style={styles.tableCell} content={data?.indoorServiceData?.stats?.recd_amt} />
//                 </View>
//                 <View style={styles.tableCol}>
//                   <Text style={styles.tableCell} content={data?.indoorServiceData?.stats?.bal_amt} />
//                 </View>
//               </View>
//             </View>
//             <View style={styles.table2}>
//               <View style={styles.tableRow}>
//                 <View
//                   style={{
//                     width: '20.28%',
//                     borderStyle: 'solid',
//                     borderWidth: 1,
//                     borderColor: '#bfbfbf',
//                     backgroundColor: '#f0f0f0',
//                     padding: 5
//                   }}
//                 >
//                   <Text style={styles.tableCellHeader} content="Username" />
//                 </View>
//                 <View
//                   style={{
//                     width: '20.28%',
//                     borderStyle: 'solid',
//                     borderWidth: 1,
//                     borderColor: '#bfbfbf',
//                     backgroundColor: '#f0f0f0',
//                     padding: 5
//                   }}
//                 >
//                   <Text style={styles.tableCellHeader} content="Cash" />
//                 </View>
//                 <View
//                   style={{
//                     width: '20.28%',
//                     borderStyle: 'solid',
//                     borderWidth: 1,
//                     borderColor: '#bfbfbf',
//                     backgroundColor: '#f0f0f0',
//                     padding: 5
//                   }}
//                 >
//                   <Text style={styles.tableCellHeader} content="Debit Card" />
//                 </View>
//                 <View
//                   style={{
//                     width: '20.28%',
//                     borderStyle: 'solid',
//                     borderWidth: 1,
//                     borderColor: '#bfbfbf',
//                     backgroundColor: '#f0f0f0',
//                     padding: 5
//                   }}
//                 >
//                   <Text style={styles.tableCellHeader} content="UPI" />
//                 </View>
//                 <View
//                   style={{
//                     width: '20.28%',
//                     borderStyle: 'solid',
//                     borderWidth: 1,
//                     borderColor: '#bfbfbf',
//                     backgroundColor: '#f0f0f0',
//                     padding: 5
//                   }}
//                 >
//                   <Text style={styles.tableCellHeader} content="Total" />
//                 </View>
//               </View>
//               {data.services &&
//                 data.services.map((service, index) => (
//                   <View key={index} style={styles.tableRow}>
//                     <View style={styles.tableCol}>
//                       <Text style={styles.tableCell} content={index + 1} />
//                     </View>
//                     <View style={styles.tableCol}>
//                       <Text style={styles.tableCell} content={service.service} />
//                     </View>
//                     <View style={styles.tableCol}>
//                       <Text style={styles.tableCell} content={service.quantity} />
//                     </View>
//                     <View style={styles.tableCol}>
//                       <Text style={styles.tableCell} content={service.rate} />
//                     </View>
//                     <View style={styles.tableCol}>
//                       <Text style={styles.tableCell} content={service.amount} />
//                     </View>
//                     <View style={styles.tableCol}>
//                       <Text style={styles.tableCell} content={service.disc_amt} />
//                     </View>
//                     <View style={styles.tableCol}>
//                       <Text style={styles.tableCell} content={0} />
//                     </View>
//                     <View style={styles.tableCol}>
//                       <Text style={styles.tableCell} content={service.net_amt} />
//                     </View>
//                   </View>
//                 ))}
//             </View>
//           </Page>
//         </Document>
//       </PDFViewer>
//     </div>
//   );
// };

// export default CollectionSummaryReport;

import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage,
  Font
} from '@react-pdf/renderer';
import { dateFormatter, getCurrentDateTime } from '../../../../../utils';

Font.register({
  family: 'Roboto',
  fonts: [{ src: '/Roboto-Bold.ttf', fontWeight: 'bold' }]
});
const styles = StyleSheet.create({
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  line: {
    height: 0.6,
    backgroundColor: 'black',
    marginVertical: 10,
    marginTop: '40px'
  },
  line2: {
    height: 0.4,
    backgroundColor: 'black',
    marginVertical: 10
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    border: '1px Solid black',
    padding: '10px'
  },
  contentContainer2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0
  },
  column: {
    flex: 1,
    paddingHorizontal: 10
  },
  row: {
    flexDirection: 'row',
    marginBottom: 0
  },
  boldText: {
    fontFamily: 'Roboto',
    fontWeight: 'ultrabold'
  },
  text: {
    fontSize: 9,
    display: 'inline-block'
  },
  textBold: {
    fontSize: 9,
    fontWeight: 'bold'
  },
  textUnderlined: {
    textDecoration: 'underline'
  },
  columnHeader: {
    width: '10%',
    backgroundColor: '#1976D2',
    color: 'white',
    padding: 5,
    textAlign: 'center'
  },
  columnContent: {
    width: '12%',
    padding: 3,
    textAlign: 'center',
  }
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};
const COLORS = ['#f0f0f0', '#e0e0e0'];

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const CollectionSummaryReport = ({ data }) => {
  console.log(data);
  const user = JSON.parse(localStorage.getItem('user'));
  let totalRecdCash = 0;

  // Sum recd in opdData
  totalRecdCash += data.opdData.data
    .filter((item) => item.payment_mode === 'CASH')
    .reduce((sum, item) => sum + (item.recd || 0), 0);

  // Sum recd in opdBilling
  totalRecdCash += data.opdBillingData.data
    .filter((item) => item.pay_mode === 'CASH')
    .reduce((sum, item) => sum + (item.total_recd || 0), 0);

  // Sum recd in Indoor Service
  totalRecdCash += data.indoorServiceData.data
    .filter((item) => item.pay_mode === 'CASH')
    .reduce((sum, item) => sum + (item.total_recd || 0), 0);

  // Sum received_amount in receiptVoucherData
  totalRecdCash += data.receiptVoucherData.data
    .filter((item) => item.payment_mode === 'Cash')
    .reduce((sum, item) => sum + (item.received_amount || 0), 0);

  // Sum amount in paymentRefundData
  totalRecdCash += data.paymentRefundData.data
    .filter((item) => item.payment_mode === 'Cash')
    .reduce((sum, item) => sum - (item.amount || 0), 0);

  let totalCredit = 0;

  // Sum recd in Opd Billing
  totalCredit += data.opdBillingData.data
    .filter((item) => item.pay_mode === 'CREDIT')
    .reduce((sum, item) => sum + (item.bal_amt || 0), 0);

  // Sum recd in indoorServiceData
  totalCredit += data.indoorServiceData.data
    .filter((item) => item.pay_mode === 'Credit')
    .reduce((sum, item) => sum + (item.total_amt || 0), 0);

  let totalRefundAmount = 0;
  // Filter and sum amounts where payment_mode is "Cash"
  totalRefundAmount = data.paymentRefundData.data
    .filter((item) => item.payment_mode === 'Cash')
    .map((item) => item.amount)
    .reduce((sum, current) => sum + current, 0);

  //Other Payment Mode
  let totalOtherAmounts = 0;

  totalOtherAmounts += data.opdData.data
    .filter((item) => item.payment_mode.toUpperCase() !== 'CASH' && item.payment_mode.toUpperCase() !== 'CREDIT')
    .reduce((sum, item) => sum + (item.recd || 0), 0);

  totalOtherAmounts += data.opdBillingData.data
    .filter((item) => item.pay_mode.toUpperCase() !== 'CASH' && item.pay_mode.toUpperCase() !== 'CREDIT')
    .reduce((sum, item) => sum + (item.total_recd || 0), 0);

  totalOtherAmounts += data.indoorServiceData.data
    .filter((item) => item.pay_mode.toUpperCase() !== 'CREDIT' && item.pay_mode.toUpperCase() !== 'CASH')
    .reduce((sum, item) => sum + (item.total_recd || 0), 0);

  totalOtherAmounts += data.receiptVoucherData.data
    .filter((item) => item.payment_mode.toUpperCase() !== 'CASH' && item.payment_mode.toUpperCase() !== 'CREDIT')
    .reduce((sum, item) => sum + (item.received_amount || 0), 0);

  function formatDate(dateString) {
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }
  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title="Collection Summary Report ">
          <Page style={styles.page} size="A4" orientation="landscape">
            <PDFImage
              src="/logo_Hospital_m.jpeg"
              style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
            />
            <Text
              style={{ ...styles.boldText, textAlign: 'center', fontSize: 10 }}
              content="BILL WISE COLLECTION SUMMARY"
            />
            <View style={styles.row}>
              <Text style={{...styles.columnHeader, width:'9%'}} content="Sr No." />
              <Text style={styles.columnHeader} content=" Bill Date" />
              <Text style={styles.columnHeader} content="Opd Type" />
              <Text style={{ ...styles.columnHeader, width: '25%' }} content="Patient Name" />
              <Text style={styles.columnHeader} content="Uhid No." />
              <Text style={styles.columnHeader} content="Adm No" />
              <Text style={styles.columnHeader} content="Paymode" />
              {/* <Text style={styles.columnHeader} content="Txn No" /> */}
              <Text style={{ ...styles.columnHeader, width: '20%' }} content="Consultant" />
              <Text style={{ ...styles.columnHeader, width: '17%' }} content="Services" />
              <Text style={{...styles.columnHeader, width: '13%'}} content="Panel" />
              {/* <Text style={styles.columnHeader} content="Bill Amt." /> */}
              {/* <Text style={styles.columnHeader} content="Dis Amt." /> */}
              <Text style={{ ...styles.columnHeader,  }} content="Recd Amt." />
              {/* <Text style={styles.columnHeader} content="Bal. Amt." /> */}
            </View>
            <View style={styles.row}>
              <Text style={{ fontSize: '10px' }} content="OPD " />
            </View>
            {data &&
              data?.opdData?.data?.map((data, index) => (
                <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                  <Text style={{...styles.columnContent, width:'9%'}} content={index + 1} />
                  <Text style={styles.columnContent} content={formatDate(data?.date)} />
                  <Text style={{...styles.columnContent, textAlign:'left'}} content="OPD" />
                  <Text style={{ ...styles.columnContent, width: '25%', textAlign:'left' }}
                    content={`${data.name_suffix} ${data.first_name} ${data.last_name}`} />
                  <Text style={styles.columnContent} content={data.uhid} />
                  <Text style={styles.columnContent} content={data.adm_no_date} />
                  <Text style={{...styles.columnContent, textAlign:'left'}} content={data.payment_mode} />
                  {/* <Text style={styles.columnContent} content={data.chq_card_no} /> */}
                  <Text style={{ ...styles.columnContent, width: '20%', textAlign:'left' }} content={data.consultant.name} />
                  <Text style={{ ...styles.columnContent, width: '17%', textAlign:'left' }} content="Consultancy" />
                  <Text style={{...styles.columnContent, width: '11%', textAlign:'left' }} content={data.sponsor.name} />
                  {/* <Text style={styles.columnContent} content={data.reg} /> */}
                  {/* <Text style={styles.columnContent} content={data.disc} /> */}
                  <Text style={{...styles.columnContent, textAlign:'right', marginRight:'10px'}} content={data.recd} />
                  {/* <Text style={styles.columnContent} content={data.bal} /> */}
                </View>
              ))}
            <View style={{ marginLeft: '76%', marginTop: '7px', flexDirection: 'row', marginBottom: 0 }}>
              <Text style={{ ...styles.columnContent, width: '84%', fontSize: "9px", fontFamily: "Roboto", color:'red' }} content="OPD TOTAL : " />
              {/* <Text style={{ ...styles.columnContent, width: '43px', fontSize: "8px", fontFamily: "Roboto", }} content={data?.opdData?.stats?.bill_amt} /> */}
              {/* <Text style={{ ...styles.columnContent, width: '40px', fontSize: "8px", fontFamily: "Roboto", }} content={data?.opdData?.stats?.disc_amt} /> */}
              <Text style={{ ...styles.columnContent, fontSize: "8px", fontFamily: "Roboto", }} content={Math.round(data?.opdData?.stats?.recd_amt)} />
              {/* <Text style={{ ...styles.columnContent, fontSize: "8px", fontFamily: "Roboto", }} content={Math.round(data?.opdData?.stats?.bal_amt)} /> */}
            </View>
            <View style={styles.row}>
              <Text style={{ fontSize: '10px' }} content="OPD Billing" />
            </View>
            {data &&
              data?.opdBillingData?.data?.map((data, index) => (
                <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                  <Text style={{...styles.columnContent, width:'9%'}} content={index + 1} />
                  <Text style={styles.columnContent} content={formatDate(data?.date)} />
                  <Text style={{...styles.columnContent, textAlign:'left'}} content="OPD Billing" />
                  <Text style={{ ...styles.columnContent, width: '25%', textAlign:'left' }}
                    content={`${data.patient.name_suffix} ${data.patient.first_name} ${data.patient.last_name}`} />
                  <Text style={styles.columnContent} content={data.uhid} />
                  <Text style={styles.columnContent} content={data.patient.adm_no_date} />
                  <Text style={{...styles.columnContent, textAlign:'left'}} content={data.pay_mode} />
                  {/* <Text style={styles.columnContent} content={data.cheque_no} /> */}
                  <Text style={{ ...styles.columnContent, width: '20%', textAlign:'left' }} content={data.patient.consultant.name} />
                  <Text style={{ ...styles.columnContent, width: '17%', textAlign:'left' }} content={data.combinedServiceDetails
                      .map(({ service_name, test_name }) => service_name || test_name)
                      .join(', ')} />
                  <Text style={{...styles.columnContent, width: '11%', textAlign:'left'}} content={data.patient.sponsor.name} />
                  {/* <Text style={styles.columnContent} content={data.total_amt} /> */}
                  {/* <Text style={styles.columnContent} content={data.disc_amt} /> */}
                  <Text style={{...styles.columnContent, textAlign:'right', marginRight:'10px'}} content={data.total_recd} />
                  {/* <Text style={styles.columnContent} content={data.balance_amt} /> */}
                </View>
              ))}

            <View style={{ marginLeft: '73%', marginTop: '7px', flexDirection: 'row', marginBottom: 0  }}>
              <Text style={{ ...styles.columnContent, width: '80%', fontSize: '8px', fontSize: "9px", fontFamily: "Roboto", color:'red' }} content="OPD BILLING TOTAL :" />
              {/* <Text style={{ ...styles.columnContent, width: '43px', fontSize: "8px", fontFamily: "Roboto", }}
                content={data?.opdBillingData?.stats?.bill_amt} />
              <Text style={{ ...styles.columnContent, width: '42px', fontSize: "8px", fontFamily: "Roboto", }}
                content={data?.opdBillingData?.stats?.disc_amt} /> */}
              <Text style={{ ...styles.columnContent, width: '41px', fontSize: "8px", fontFamily: "Roboto", }}
                content={data?.opdBillingData?.stats?.recd_amt} />
              {/* <Text style={{ ...styles.columnContent, fontSize: "8px", fontFamily: "Roboto", }} content={data?.opdBillingData?.stats?.bal_amt} /> */}
            </View>

            <View style={styles.row}>
              <Text style={{ fontSize: '10px' }} content="Receipt Voucher " />
            </View>
            {data &&
              data?.receiptVoucherData?.data?.map((data, index) => (
                <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                  <Text style={{...styles.columnContent, width:'9%'}} content={index + 1} />
                  <Text style={styles.columnContent} content={formatDate(data?.date)} />
                  <Text style={{...styles.columnContent, textAlign:'left'}} content="Receipt Voucher" />
                  <Text style={{ ...styles.columnContent, textAlign:'left', width: '25%' }}
                    content={`${data.patient.name_suffix} ${data.patient.first_name} ${data.patient.last_name}`} />
                  <Text style={styles.columnContent} content={data.patient.uhid} />
                  <Text style={styles.columnContent} content={data.patient.adm_no_date} />
                  <Text style={{...styles.columnContent, textAlign:'left'}} content={data.payment_mode} />
                  {/* <Text style={styles.columnContent} content={''} /> */}
                  <Text style={{ ...styles.columnContent, textAlign:'left', width: '20%' }} content={data.patient.consultant.name} />
                  <Text style={{ ...styles.columnContent, textAlign:'left', width: '17%' }} content={''} />
                  <Text style={{...styles.columnContent, textAlign:'left', width: '13%'}} content={data.patient.sponsor.name} />
                  {/* <Text style={styles.columnContent} content={0} /> */}
                  {/* <Text style={styles.columnContent} content={0} /> */}
                  <Text style={{...styles.columnContent, textAlign:'right', marginRight:'10px' }} content={data.received_amount} />
                  {/* <Text style={styles.columnContent} content={0} /> */}
                </View>
              ))}
            <View style={{ marginLeft: '68%', marginTop: '7px', flexDirection: 'row', marginBottom: 0 }}>
              <Text
                style={{ ...styles.columnContent, width: '84%', fontSize: "9px", fontFamily: "Roboto", color:'red' }}
                content="RECIEPT VOUCHER TOTAL : "
              />
              {/* <Text
                style={{ ...styles.columnContent, width: '36px', fontSize: "8px", fontFamily: "Roboto", }}
                content={data?.receiptVoucherData?.stats?.bill_amt}
              />
              <Text
                style={{ ...styles.columnContent, width: '43px', fontSize: "8px", fontFamily: "Roboto", }}
                content={data?.receiptVoucherData?.stats?.disc_amt}
              /> */}
              <Text
                style={{ ...styles.columnContent, fontSize: "8px", fontFamily: "Roboto", }}
                content={data?.receiptVoucherData?.stats?.recd_amt}
              />
              {/* <Text
                style={{ ...styles.columnContent, fontSize: "8px", fontFamily: "Roboto", }} 
                content={data?.receiptVoucherData?.stats?.bal_amt} /> */}
            </View>

            <View style={{ ...styles.row, marginTop: '2%' }}>
              <Text style={{ fontSize: '10px' }} content="Payment Refund Voucher " />
            </View>
            {data &&
              data?.paymentRefundData?.data?.map((data, index) => (
                <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                  <Text style={{ ...styles.columnContent, width: '9%' }} content={index + 1} />
                  <Text style={styles.columnContent} content={formatDate(data?.date)} />
                  <Text style={{ ...styles.columnContent, textAlign:'left' }} content="Payment Refund" />
                  <Text
                    style={{ ...styles.columnContent, width: '25%', textAlign:'left' }}
                    content={`${data.patient.name_suffix} ${data.patient.first_name} ${data.patient.last_name}`}
                  />
                  <Text style={styles.columnContent} content={data.patient.uhid} />
                  <Text style={styles.columnContent} content={data.patient.adm_no_date} />
                  <Text style={{ ...styles.columnContent, textAlign:'left' }} content={data.payment_mode} />
                  {/* <Text style={styles.columnContent} content={''} /> */}
                  <Text style={{ ...styles.columnContent, width: '20%', textAlign:'left' }} content={data.patient.consultant.name} />
                  <Text style={{ ...styles.columnContent, width: '17%', textAlign:'left' }} content={''} />
                  <Text style={{ ...styles.columnContent, width: '13%', textAlign:'left' }} content={data.patient.sponsor.name} />
                  {/* <Text style={styles.columnContent} content={0} /> */}
                  {/* <Text style={styles.columnContent} content={0} /> */}
                  <Text style={{ ...styles.columnContent, textAlign:'right', marginRight:'10px' }} content={data.amount} />
                  {/* <Text style={styles.columnContent} content={0} /> */}
                </View>
              ))}

            <View style={styles.row}>
              <Text style={{ fontSize: '10px' }} content="IPD Billing" />
            </View>
            {data &&
              data?.indoorServiceData?.data?.map((data, index) => (
                <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                  <Text style={{...styles.columnContent, width:'9%'}} content={index + 1} />
                  <Text style={styles.columnContent} content={formatDate(data?.date)} />
                  <Text style={{...styles.columnContent, textAlign:'left'}} content="IPD Billing" />
                  <Text
                    style={{ ...styles.columnContent, width: '25%', textAlign:'left' }}
                    content={`${data.patient.name_suffix} ${data.patient.first_name} ${data.patient.last_name}`}
                  />
                  <Text style={styles.columnContent} content={data.uhid} />
                  <Text style={styles.columnContent} content={data.patient.adm_no_date} />
                  <Text style={{...styles.columnContent, textAlign:'left'}} content={data.pay_mode} />
                  {/* <Text style={styles.columnContent} content={data.cheque_no} /> */}
                  <Text style={{ ...styles.columnContent, width:'20%', textAlign:'left' }} content={data.patient.consultant.name} />
                  <Text
                    style={{ ...styles.columnContent, width:'17%', textAlign:'left' }}
                    content={data.combinedServiceDetails.map(({ service_name, test_name }) => service_name || test_name)
                      .join(', ')}
                  />
                  <Text style={{ ...styles.columnContent, width:'13%', textAlign:'left' }} content={data.patient.sponsor.name} />
                  {/* <Text style={styles.columnContent} content={data.total_amt} />
                  <Text style={styles.columnContent} content={data.disc_amt} /> */}
                  <Text style={{...styles.columnContent, textAlign:'right', marginRight:'10px' }} content={data.total_recd} />
                  {/* <Text style={styles.columnContent} content={data.balance_amt} /> */}
                </View>
              ))}
            <View style={{ marginLeft: '71%', marginTop: '7px', flexDirection: 'row', marginBottom: 0 }}>
              <Text style={{ ...styles.columnContent, width: '84%', fontSize: "9px", fontFamily: "Roboto", color:'red' }} 
              content="IPD BILLING TOTAL :" />
              {/* <Text style={{ ...styles.columnContent, width: '43px', fontSize: "8px", fontFamily: "Roboto", }}
                content={data?.indoorServiceData?.stats?.bill_amt} />
              <Text style={{ ...styles.columnContent, width: '38px', fontSize: "8px", fontFamily: "Roboto", }}
                content={data?.indoorServiceData?.stats?.disc_amt} /> */}
              <Text style={{ ...styles.columnContent, fontSize: "8px", fontFamily: "Roboto", }}
                content={data?.indoorServiceData?.stats?.recd_amt} />
              {/* <Text style={{ ...styles.columnContent, fontSize: "8px", fontFamily: "Roboto", }}
                content={data?.indoorServiceData?.stats?.bal_amt} /> */}
            </View>

            <View style={{ ...styles.row, width: '100%', marginTop: '30px' }}>
              <Text style={{ ...styles.columnHeader, width: '100%' }} content="User Name" />
              <Text style={{ ...styles.columnHeader, width: '100%' }} content="Cash" />
              <Text style={{ ...styles.columnHeader, width: '100%' }} content="Bank" />
              <Text style={{ ...styles.columnHeader, width: '100%' }} content="Credit" />
              <Text style={{ ...styles.columnHeader, width: '100%' }} content="Refund" />
            </View>
            <View style={{ ...styles.row }}>
              <Text style={{ ...styles.columnContent, width: '20%' }} content={user.name} />
              <Text style={{ ...styles.columnContent, width: '20%' }} content={totalRecdCash} />
              <Text style={{ ...styles.columnContent, width: '20%' }} content={totalOtherAmounts} />
              <Text style={{ ...styles.columnContent, width: '20%' }} content={totalCredit} />
              <Text style={{ ...styles.columnContent, width: '20%' }} content={totalRefundAmount} />
            </View>
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};

export default CollectionSummaryReport;
